import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Modal, Typography, message, Tag } from 'antd';
import { SearchOutlined, TransactionOutlined, RedEnvelopeOutlined, BoldOutlined, VerifiedOutlined } from '@ant-design/icons';
import { request } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const { Paragraph, Text } = Typography;
const Hdgtz = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formxf] = Form.useForm();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [bangm, setbangm] = useState([]);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
  const [titnr, settitnr] = useState();// 选择的产品信息
  const [ticks, setticks] = useState([]);


  useEffect(() => {
    async function getau() {
      const res = await request.post('/hdgtz_list')
      setbangm(res.rescode)
    }
    getau()
  }, [ticks])

  const gohf = (v, b) => {
    setccpxx(v)
    b === "cs" && settitnr("认证次数")
    b === "sq" && settitnr("胜券余额")
    b === "yx" && settitnr("营销余额")
    b === "ye" && settitnr("账户余额")
    formxf.setFieldsValue({ dbno: v.key, dw: b ,valu:''});// 回传发送短信订单号码
    setOpen(true)

  }

  const onFxfsq = async (e) => {
    const rq = await request.post('/hdgtz', e)
    setOpen(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }







  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });




  const columns = [
    {
      title: "",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tag color="green" onClick={() => gohf(record, 'ye')}><TransactionOutlined />余额</Tag>
         {false && <Tag color="cyan" onClick={() => gohf(record, 'yx')}><RedEnvelopeOutlined />营销</Tag>}
          <Tag color="blue" onClick={() => gohf(record, 'sq')}><BoldOutlined />胜券</Tag>
          <Tag color="purple" onClick={() => gohf(record, 'cs')}><VerifiedOutlined />次数</Tag>
        </Space>
      ),
    },
    {
      title: '用户编号',
      dataIndex: 'userid',
      key: 'userid',
      ...getColumnSearchProps('userid'),
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },

    {
      title: '用户名',
      dataIndex: 'username',
      key: 'username',
      ...getColumnSearchProps('username'),
    },
    {
      title: '数据量',
      dataIndex: 'hznum',
      key: 'hznum',
    },

    {
      title: '到期时间',
      key: 'dqtime',
      ...getColumnSearchProps('dqtime'),
      dataIndex: 'dqtime',
    },
    {
      title: '钱包余额',
      key: 'qbje',
      dataIndex: 'qbje',
    },
    {
      title: '胜券余额',
      key: 'dqye',
      dataIndex: 'dqye',
    },
    {
      title: '营销余额',
      key: 'yxye',
      dataIndex: 'yxye',
    },
    {
      title: '推广收益',
      key: 'tgsy',
      dataIndex: 'tgsy',
    },
    {
      title: '认证余数',
      key: 'rzn',
      dataIndex: 'rzn',
    },
    {
      title: '注册时间',
      key: 'zctime',
      dataIndex: 'zctime',
    },

  ];


  return (
    <>

      <ConfigProvider locale={zhCN} >
        {contextHolder}

        <div >
          <Form form={form} component={false}>

            <Table columns={columns} dataSource={bangm} size="small" />

          </Form>



        </div>


        <Modal
          // title="数据修复申请表"
          footer={null}
          centered
          open={open}
          onOk={() => onFxfsq()}
          onCancel={() => setOpen(false)}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          <Paragraph> 数据编号：{ccpxx.userid} <Text>用户名：{ccpxx.username}</Text> </Paragraph>

          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}
          >

            <Form.Item name='dbno'
              hidden={true}
            >
              <Input />
            </Form.Item>
            <Form.Item name='dw'
             hidden={true} 
            >
              <Input />
            </Form.Item>



            <Form.Item label={titnr} name='valu' rules={[{ required: true, message: '填写对应数字！' },]}>
              <Input />
            </Form.Item>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                block={true} >
                提          交
              </Button>
            </Form.Item>


          </Form>
        </Modal>



      </ConfigProvider>
    </>

  );
};
export default Hdgtz;